import { render, staticRenderFns } from "./ChartCandle.vue?vue&type=template&id=1b912885&"
import script from "./ChartCandle.vue?vue&type=script&lang=js&"
export * from "./ChartCandle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports